// Copyright 2018 Sorama B.V.

import { MeasurementChannelSelection } from "datatypes/MeasurementChannelSelection";
import { IWorkflowPropertyParser } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyParser";

export class MeasurementChannelSelectionParser implements IWorkflowPropertyParser<MeasurementChannelSelection> {
    public toWorkflowProperty(selection: MeasurementChannelSelection): string {
        return selection.measurementId + "," + selection.selectedChannels;
    }

    public fromWorkflowProperty(selectionString: string): MeasurementChannelSelection {
        const elements = selectionString.split(",");

        return <MeasurementChannelSelection>{
            measurementId: elements[0],
            selectedChannels: [...new Set(elements.slice(1).map((x) => Number(x)))], // Make sure that all channels are unique
        };
    }
}
